const ROOT = `${process.env.REACT_APP_URL_API_V2}neighborhoods/`
// const ROOT = 'neighborhoods/'

export default {
	arrayListDropdown: `${ROOT}city/`
}
